import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=caedc3ee&scoped=true&"
import script from "./groups.vue?vue&type=script&lang=ts&"
export * from "./groups.vue?vue&type=script&lang=ts&"
import style0 from "./groups.vue?vue&type=style&index=0&id=caedc3ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caedc3ee",
  null
  
)

export default component.exports